var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 0C7.17745 0 0 7.17745 0 15.9995C0 24.8215 7.17745 32 16.0005 32C24.8236 32 32.0011 24.8226 32.0011 15.9995C32.0011 7.17639 24.8226 0 16.0005 0ZM16.0005 1.80711C19.2674 1.80711 22.2792 2.9173 24.6802 4.77859L21.3199 8.13891C20.7122 5.59981 18.5842 3.72471 16.0505 3.72471C13.0439 3.72471 10.6068 6.36579 10.6068 9.62305C10.6068 12.2025 12.1356 14.3931 14.2635 15.1942L13.2373 16.2204L12.8909 15.9803C12.6243 15.7955 12.2822 15.7572 11.9815 15.8784L7.85631 17.5389C6.81093 17.9596 6.04495 18.8743 5.81442 19.9781L5.2896 22.4938C5.18655 22.9889 5.34484 23.4659 5.65825 23.8005L4.77753 24.6813C2.91624 22.2803 1.80605 19.2684 1.80605 16.0016C1.80605 8.17503 8.1729 1.80817 15.9995 1.80817L16.0005 1.80711ZM16.0005 30.194C12.091 30.194 8.54474 28.6046 5.9759 26.039L26.0379 5.97484C28.6046 8.54474 30.1929 12.0899 30.1929 15.9995C30.1929 23.826 23.826 30.1929 15.9995 30.1929L16.0005 30.194Z",
    fill: "#734BD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8101 22.4916L26.2789 19.9462C26.0516 18.8593 25.3047 17.9542 24.2817 17.525L20.3636 15.8836C20.0651 15.7582 19.723 15.7912 19.4531 15.9718L18.5947 16.5465C18.2356 16.7877 17.8489 16.9672 17.4495 17.0915L10.2773 24.2637H25.3685C26.3023 24.2637 26.9992 23.4053 26.8091 22.4916H26.8101Z",
    fill: "#734BD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/BlockIcon.890856824e5fe3082b7239855c3176db.svg";
export { ForwardRef as ReactComponent };